import React from "react";
import { SUPPORTED_LANGUAGES } from "../../i18n/config";
import { useTranslation } from "../../i18n/useTranslation";

interface LanguageSelectorProps {
    value: string;
    onChange: (lang: string) => void;
    className?: string;
    disabled?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange, className = '', disabled = false }) => {
    const { t } = useTranslation();

    return (
        <select
            aria-label={t('common.field.language')}
            className={`bg-white rounded-full px-4 py-[10.5px] focus:outline-none cursor-pointer ${className}`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
        >
            {SUPPORTED_LANGUAGES.map(({ code, label, flag }) => (
                <option key={code} value={code}>{`${flag} ${label}`}</option>
            ))}
        </select>
    );
};

export default LanguageSelector;
